import React, { useState } from 'react';
import { loadLeaderboard, loadHighScore, loadWeeklyScore } from '../engine/GameState';

export default function LeaderboardScreen({ onClose }) {
  const [tab, setTab] = useState('global');
  const leaderboard = loadLeaderboard();
  const myHighScore = loadHighScore();
  const weeklyScore = loadWeeklyScore();

  const myEntry = { name: 'You', score: myHighScore, avatar: '🐒', isMe: true };
  const allEntries = [...leaderboard, myEntry]?.sort((a, b) => b?.score - a?.score)?.map((e, i) => ({ ...e, rank: i + 1 }));

  const RANK_STYLES = [
    { bg: 'rgba(245,158,11,0.2)', border: 'rgba(245,158,11,0.5)', color: '#f59e0b' },
    { bg: 'rgba(156,163,175,0.2)', border: 'rgba(156,163,175,0.5)', color: '#9ca3af' },
    { bg: 'rgba(205,124,47,0.2)', border: 'rgba(205,124,47,0.5)', color: '#cd7c2f' },
  ];

  return (
    <div
      className="absolute inset-0 z-30 flex items-center justify-center"
      style={{ background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(4px)' }}
    >
      <div
        className="w-full max-w-sm mx-4 rounded-2xl overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, #1a0a2e, #2d1a4e)',
          border: '2px solid rgba(99,102,241,0.5)',
          maxHeight: '80vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="flex items-center justify-between p-4 border-b" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          <h2 className="font-heading font-bold text-xl text-white">🏆 Leaderboard</h2>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ background: 'rgba(255,255,255,0.1)', color: 'white' }}
          >
            ✕
          </button>
        </div>

        <div className="flex border-b" style={{ borderColor: 'rgba(255,255,255,0.1)' }}>
          {['global', 'weekly']?.map(t => (
            <button
              key={t}
              onClick={() => setTab(t)}
              className="flex-1 py-3 text-sm font-semibold capitalize transition-all"
              style={{
                color: tab === t ? '#6366f1' : 'rgba(255,255,255,0.5)',
                borderBottom: tab === t ? '2px solid #6366f1' : '2px solid transparent',
              }}
            >
              {t === 'global' ? '🌍 Global' : '📅 Weekly'}
            </button>
          ))}
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-2">
          {tab === 'weekly' && (
            <div className="p-3 rounded-xl mb-3" style={{ background: 'rgba(99,102,241,0.1)', border: '1px solid rgba(99,102,241,0.3)' }}>
              <p className="font-caption text-xs" style={{ color: 'rgba(255,255,255,0.5)' }}>Weekly resets every Monday. Compete for top spot!</p>
              <p className="font-data text-lg font-bold mt-1" style={{ color: '#6366f1' }}>Your weekly: {weeklyScore?.score?.toLocaleString()}</p>
            </div>
          )}
          {allEntries?.map(entry => (
            <div
              key={entry?.name + entry?.rank}
              className="flex items-center gap-3 p-3 rounded-xl transition-all"
              style={{
                background: entry?.isMe ? 'rgba(99,102,241,0.2)' : 'rgba(255,255,255,0.04)',
                border: entry?.isMe ? '1px solid rgba(99,102,241,0.5)' : '1px solid rgba(255,255,255,0.08)',
              }}
            >
              <div
                className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold flex-shrink-0"
                style={{
                  background: entry?.rank <= 3 ? RANK_STYLES?.[entry?.rank - 1]?.bg : 'rgba(255,255,255,0.08)',
                  border: `1px solid ${entry?.rank <= 3 ? RANK_STYLES?.[entry?.rank - 1]?.border : 'rgba(255,255,255,0.15)'}`,
                  color: entry?.rank <= 3 ? RANK_STYLES?.[entry?.rank - 1]?.color : 'rgba(255,255,255,0.5)',
                }}
              >
                {entry?.rank <= 3 ? ['🥇', '🥈', '🥉']?.[entry?.rank - 1] : entry?.rank}
              </div>
              <div className="text-xl">{entry?.avatar}</div>
              <span
                className="flex-1 font-body text-sm truncate"
                style={{ color: entry?.isMe ? '#a5b4fc' : 'white', fontWeight: entry?.isMe ? 700 : 400 }}
              >
                {entry?.name} {entry?.isMe ? '(You)' : ''}
              </span>
              <span className="font-data text-sm font-bold" style={{ color: entry?.rank === 1 ? '#f59e0b' : 'rgba(255,255,255,0.8)' }}>
                {entry?.score?.toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
